// frontend/src/lib/firebaseAuth.ts
import { Auth } from 'firebase/auth';
import { initializeFirebaseCore } from './firebase/firebase';

// Create a promise that resolves to the Auth service instance
// Handle server-side contexts gracefully
let authPromise: Promise<Auth | null>;

if (typeof window === 'undefined') {
    // We're on the server-side
    console.log(
        '[firebaseAuth] Detected server-side context. Returning a dummy Auth promise.'
    );
    // Return a promise that resolves to null, which is safer for SSR
    authPromise = Promise.resolve(null);
} else {
    // We're on the client-side
    authPromise = initializeFirebaseCore()
        .then((services) => {
            if (!services.auth) {
                // This could happen if:
                // 1. The core module couldn't initialize (config issues)
                // 2. We're somehow still on the server despite the typeof window check
                console.warn(
                    '[firebaseAuth] Firebase Auth service is not available from initializeFirebaseCore (client).'
                );
                // Return null instead of throwing, to avoid breaking consuming components
                // They should check if auth is null before using it
                return null;
            }
            console.log(
                '[firebaseAuth] Auth service obtained from initializeFirebaseCore (client).'
            );
            return services.auth;
        })
        .catch((error) => {
            console.error(
                '[firebaseAuth] Error obtaining Auth service from initializeFirebaseCore (client):',
                error
            );
            // Return null instead of re-throwing, to avoid breaking consuming components
            return null;
        });
}

export { authPromise as auth };

// Also export a helper function that components can use for reactive checking
export function isAuthAvailable(): boolean {
    return typeof window !== 'undefined';
}
